// AI Generated File
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';
import { UserRepoService } from '@client/app/services/api/user-repo/user-repo.service';
import { UserToOutputModel } from '@client/app/forms/domain/steps/users/user-to-output.model';

@Component({
    selector: 'form-domain-groups-users',
    templateUrl: './users.component.html',
    standalone: false,
})
export class FormDomainGroupsUsersComponent extends BaseContainerComponentController implements OnInit, OnChanges {
    @Input() domainGroup: any;
    users: any[] = [];
    progress: any;
    updatedUsers: UserToOutputModel[] = [];

    constructor (
        private userRepoService: UserRepoService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.activate();
    }

    ngOnChanges (changes: any) {
        if (!this.domainGroup.domain_group_members) {
            this.getPage();
        }
    }

    private activate () {
        this.domainGroup.domain_group_members = this.domainGroup.domain_group_members || [];
        this.getPage();
    }

    override getPage () {
        this.progress = this.userRepoService
            .getAll({ page_size: this.pageSize, page: this.page })
            .then((users: any) => {
                this.users = users;
                this.merge();
                const updatedUsers = this.copyCollection(this.users);

                for (let i = 0; i < updatedUsers.length; i += 1) {
                    const userToOutput = new UserToOutputModel(updatedUsers[i]);
                    userToOutput.name = userToOutput.getName();
                    userToOutput.isVisible = this.isVisible(userToOutput);
                    userToOutput.hasSendReport = this.hasSendReport(userToOutput);
                    updatedUsers[i] = userToOutput;
                }

                this.updatedUsers = this.copyCollection(updatedUsers);
            });
    }

    private copyCollection (collection: any, start = 0, end?): any[] {
        const newCollection: any = collection.slice(start, end);
        newCollection.total = collection.total || 0;
        newCollection.perPage = collection.perPage;
        newCollection.currentPage = collection.currentPage;
        return newCollection;
    }

    private isVisible (user: UserToOutputModel): boolean {
        const domainUser = this.domainGroup.domain_group_members.find((dgm: any) => dgm.user_id === user.id);
        return domainUser ? domainUser.visible : false;
    }

    private hasSendReport (user: UserToOutputModel): boolean {
        const domainUser = this.domainGroup.domain_group_members.find((dgm: any) => dgm.user_id === user.id);
        return domainUser ? domainUser.send_report : false;
    }

    toggleVisible (user: UserToOutputModel) {
        const index = this.findUser(this.domainGroup.domain_group_members, user);
        if (index === -1) {
            return;
        }

        user.isVisible = !user.isVisible;
        const domainUser = this.domainGroup.domain_group_members[index];
        domainUser.visible = !domainUser.visible;
        if (!user.isVisible) {
            user.hasSendReport = false;
            domainUser.send_report = false;
        }
    }

    toggleSendReport (user: UserToOutputModel) {
        const index = this.findUser(this.domainGroup.domain_group_members, user);
        if (index === -1) {
            return;
        }

        user.hasSendReport = !user.hasSendReport;
        this.domainGroup.domain_group_members[index].send_report = !this.domainGroup.domain_group_members[index].send_report;
    }

    private merge () {
        if (!this.users || !this.domainGroup.domain_group_members) {
            return;
        }

        for (let i = 0; i < this.users.length; i++) {
            const userIndex = this.findUser(this.domainGroup.domain_group_members, this.users[i]);
            if (userIndex > -1) {
                if (!this.domainGroup.domain_group_members[userIndex].hasOwnProperty('user')) {
                    this.domainGroup.domain_group_members[userIndex].user = this.users[i];
                }
                if (this.domainGroup.domain_group_members[userIndex].user.customer_admin) {
                    this.domainGroup.domain_group_members[userIndex].visible = true;
                }
                continue;
            }

            this.domainGroup.domain_group_members.push({
                domain_group_id: this.domainGroup.id,
                user_id: this.users[i].id,
                visible: this.users[i].customer_admin === true,
                send_report: false,
                user: this.users[i],
            });
        }
    }

    trackByUserId (index: number, user: UserToOutputModel): number {
        return user.id;
    }

    private findUser (domainUsers, user) {
        return domainUsers.findIndex((du: any) => du.user_id === user.id);
    }
}
